<template>
  <div v-if="interview.id">
    <b-card :title="$t('application.answerCard.title')">
      <table class="mt-7 mt-xl-0 w-100">
        <tr>
          <th>{{ $t('application.answerCard.tableHeaders.status') }}</th>
          <th>{{ $t('application.answerCard.tableHeaders.expiredDate') }}</th>
          <th />
        </tr>
        <tr>
          <td>
            <b-badge
              :variant="getBadgeStatus(getInterviewStatus())"
              class="mgRight-5"
              style="text-transform: capitalize">{{ getInterviewStatus() }}</b-badge>
          </td>
          <td>
            <b-card-text>
              {{
                interview.expiredDate.toDate().toLocaleString('fi', {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                })
              }}
            </b-card-text>
          </td>
          <td>
            <b-button
              v-b-modal.answers-modal
              variant="outline-info"
              size="sm"
              :disabled="!interview || !interview.submitted"
            >
              {{ $t('application.answerCard.seeAnswers') }}
            </b-button>
          </td>
        </tr>
      </table>
    </b-card>

    <b-modal
      v-if="interview"
      id="answers-modal"
      :title="$t('application.answerCard.answerModal.header')"
      :no-close-on-backdrop="true"
      ok-only
      ok-variant="primary"
      ok-title="OK"
    >
      <template>
        <ul style="margin-bottom: 3rem; list-style: none;">
          <li v-for="(step, index) in steps" :key="index">
            <p>{{ index + 1 }} . {{ step.question }}</p>
            <audio v-if="step.questionType === 'audio'" :src="step.answer" controls />
            <p v-else style="color: black; font-style: italic">
              {{ step.answer || 'not answer' }}
            </p>
            <hr v-if="index < steps.length - 1" />
          </li>
        </ul>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BBadge, BCardText, BButton } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BBadge,
    BCardText,
    BButton,
  },
  props: {
    interview: {
      type: Object,
      required: true,
    },
  },
  computed: {
    steps() {
      return this.interview.steps.filter(
        step => step.questionType !== 'intro' && step.questionType !== 'audioTest'
      )
    },
  },
  methods: {
    getInterviewStatus() {
      let status = ''
      if (this.interview.id && !this.interview?.submitted) {
        if (new Date() <= this.interview.expiredDate.toDate()) {
          status = 'in progress'
        } else {
          status = 'expired'
        }
      } else {
        status = 'submitted'
      }
      return status
    },
    getBadgeStatus(status) {
      let variant = ''
      if (status === 'submitted') {
        variant = 'light-success'
      } else if (status === 'in progress') {
        variant = 'warning'
      } else if (status === 'expired') {
        variant = 'danger'
      } else {
        variant = 'info'
      }
      return variant
    },
  },
}
</script>

<style>
.mgRight-5 {
  margin-right: 3px;
}
</style>
